// src/components/elements/Title.js
import React from 'react';

const TitleElement = ({ Title, Subtitle, TextColorHexCode }) => {
  const titleStyle = {
    color: TextColorHexCode || 'inherit', // Standardfarbe, falls kein Hex-Code gesetzt
  };

  return (
    <div className="mb-3" style={titleStyle}>
      {Title && <h2 className="h4 fw-bold">{Title}</h2>}
      {Subtitle && <p className="">{Subtitle}</p>}
    </div>
  );
};

export default TitleElement;
